import React  , { Component } from 'react'

import {  HomeSlider,
          HomeDeals,
          VideoSliderItem,
          PostSliderItem,
          HomeTitle,
          ResponsiveYouTubeIframe ,
          CoverSection        } from '../../Components/UI/UI'

import { newPosts, TouristInfoPosts  } from "../../Data/Data";
import { newPostdata } from "../../Posts/PostsData"
import { getWeather, getUrl, asyncgetWeather } from "../../Utility/Utility";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "../innerPage.css"
import "./SearchPage.css"

const getParam = window.location.search;
    // console.log(typeof getParam);
    // console.log(getParam);
const urlParams = new URLSearchParams(getParam);
const keyWord = urlParams.get('q');
console.log(typeof keyWord);

class SearchPage extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,
    keyWord: keyWord,
    isResult: false,
  }

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
        var weather = response[0];
     

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                        
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}


  render(){
    console.log('typeOf keyword:', typeof this.state.keyWord);
    console.log('this.state.keyWordTTTTTTTTT:', this.state.keyWord);
    const lowerCaseKeyWord = this.state.keyWord;
    const toLowerCaseKeyWord = lowerCaseKeyWord.toLowerCase();
   
    const noResults ='Soory, no results';

    // get all posts 

    const  posts = [ ...newPosts, ...TouristInfoPosts] ;

    // console.log('posts:', posts);


    const d = [...newPostdata];

    let searchResults = posts.map( (o,i) => {

      // console.log('o:',o);

        let url = null;
        let html = null;
        let component = null;
        let cssClass="";
        let category = o.ctg;
        let title = o.title;
        let ids = o.id;

         console.log('toLowerCaseKeyWord:', toLowerCaseKeyWord);

   

        if (category.includes(this.state.keyWord) || title.includes(this.state.keyWord) ||category.includes(toLowerCaseKeyWord) || title.includes(toLowerCaseKeyWord)) {
      

                if (o.isVid === true) {
                  url  = "/Posts/Videos/" + o.ctg  + '/' + o.id;
                  component = <VideoSliderItem  
                                key={i}
                                title={o.title}
                                desc={""}
                                img= {o.img}
                                link={url}
                                cssClass={cssClass} />
                }else {
                  // url = "/Posts/" + o.id ;
                  url  = "/Posts/" + o.ctg  + '/' + o.id;
                  component = <PostSliderItem  
                                  key={i}
                                  title={o.title}
                                  desc={""}
                                  img= {o.img}
                                  link={url}
                                  cssClass={cssClass} />
                }

                return component;
              
          
        }      
      
    });



    let dd = d.map( (o,i) => {
      const ht = o.html();
      // console.log('ht.__html:', ht.__html);
      let h = ht.__html;
      h = h.toLowerCase();
      // console.log('h:', h);

      let url = null;
        let html = null;
        let component = null;
        let cssClass="";
        let category = o.ctg;
        let title = o.title;
        let ids = o.id;


    


        

        const current = posts.filter((objj) => {
          return objj.id === o.id
        });


        if ( current.length > 0 ) {

          const c = current[0];
           console.log(h.length);
           console.log(h);
           console.log( 'includes' , h.includes(this.state.keyWord.trim()));
            
            const regex = /this.state.keyWord/g;
          const found = h.match(regex);
          console.log('foundfoundfound', found);
          // alert(h.includes(this.state.keyWord))
        

          if ( h.includes(this.state.keyWord.trim()) == true || category.includes(this.state.keyWord) || title.includes(this.state.keyWord) ||category.includes(toLowerCaseKeyWord) || title.includes(toLowerCaseKeyWord)) {

        

                  if (o.isVid === true) {
                    url  = "/Posts/Videos/" + o.ctg  + '/' + o.id;
                    component = <VideoSliderItem  
                                  key={i}
                                  title={c.title}
                                  desc={""}
                                  img= {c.img}
                                  link={url}
                                  cssClass={cssClass} />
                  }else {
                    // url = "/Posts/" + o.id ;
                    url  = "/Posts/" + o.ctg  + '/' + o.id;
                    component = <PostSliderItem  
                                    key={i}
                                    title={c.title}
                                    desc={""}
                                    img= {c.img}
                                    link={url}
                                    cssClass={cssClass} />
                  }

                  return component;

            
            
          }    
          
        }


    });

    // console.log('dd' , dd);
    
    searchResults = [...searchResults, ...dd]

    searchResults = searchResults.filter(function (el) {
      return el != null;
    });



    // console.log('searchResults' , searchResults);
    

    return(
      <div className="inner-page align-center page-searchpage">
        <Menu />
        
        <CoverSection desktopImg={'/posts/bank/page-search/1.jpg'} mobileImg={'/posts/bank/page-search/M.jpg'} cssClass={'telaviv'} waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather}/>
        
        <section className="live-shows-section">
          <div className="container">
            <HomeTitle>
              Search results
            </HomeTitle>
         
            <div className="live-shows-wrapper">
           {
               searchResults.length == 0
               ?
               <h3>Soory, no results</h3>
               :
               searchResults
            }

              
              
            </div>
          
          </div>
        </section>
        <Footer />
      </div>
    )
  }

}



export default SearchPage;


// WEBPACK FOOTER //
// ./src/Pages/SearchPage/SearchPage.js